import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import toastMessages from "../../helpers/toastMessage";
import { useOktaAuth } from "@okta/okta-react";
import { AxiosError } from "axios";

function useAssociateLabel(
  setSelecting: (value: boolean) => void
) {
  const authState = useOktaAuth()?.authState;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["associateLabel"],
    mutationFn: ({ orderIds, fedexLabelId }: { orderIds: number[], fedexLabelId: any }) => {
      setSelecting(true);
      return axiosInstance.put(
        '/v1/orders/associate-label',
        { orderIds, fedexLabelId },
        {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        }
      );
    },
    onSuccess: () => {
      setSelecting(false);
      queryClient.invalidateQueries({ queryKey: ["activeLabelsList"] });
      queryClient.invalidateQueries({ queryKey: ["testOrdersList"] });
    },
    onError: (error: AxiosError<any, any>) => {
      const errorMsg = error?.response?.data?.errors?.message ?? error.message;
      toastMessages.error(errorMsg);
      setSelecting(false);
    },
  });
}

export default useAssociateLabel;
